export const allPlatforms = ['microsoft', 'slack', 'google', 'email']
export const GHOST_USERS_DATE_LIMIT = new Date('2024-12-15')
export const AUTOMATIC_USERS_IMPORT_LIMIT = 1000
export const dayOfWeekMap = [
  { value: 0, name: 'app.sunday', shortName: 'app.sunday.short' },
  { value: 1, name: 'app.monday', shortName: 'app.monday.short' },
  { value: 2, name: 'app.tuesday', shortName: 'app.tuesday.short' },
  { value: 3, name: 'app.wednesday', shortName: 'app.wednesday.short' },
  { value: 4, name: 'app.thursday', shortName: 'app.thursday.short' },
  { value: 5, name: 'app.friday', shortName: 'app.friday.short' },
  { value: 6, name: 'app.saturday', shortName: 'app.saturday.short' },
]
export const GOOGLE_READ_USER_PERMISSION = 'https://www.googleapis.com/auth/admin.directory.user.readonly'

export const IMPORT_TEMPLATES_FOLDER_URL = process.env.REACT_APP_CSV_TEMPLATE_URL ? process.env.REACT_APP_CSV_TEMPLATE_URL : 'https://cdn.vacationtracker.io/templates'
export const MIGRATION_AVAILABLE_PLATFORMS = ['microsoft', 'slack', 'google', 'email']

export const IOS_MOBILE_APP_URL = 'https://apps.apple.com/app/id6745224602'
export const ANDROID_MOBILE_APP_URL = 'https://play.google.com/store/apps/details?id=io.vacationtracker.mobile'
